import {
  columnCover,
  columnInfo,
  columnName,
  columnState,
} from 'components/template-data-table-column'
import React from 'react'
import { DataTableRowActions } from './data-table-row-actions'

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnName,
  columnInfo,
  columnState,
  {
    header: 'Actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
